// Inject time-of-day / category badges into cart recommendation cards
(function () {
  const BADGE_MAP = {
    'RISE':        { label: 'Morning', color: '#f8991d' },
    'UNWIND':      { label: 'Night',   color: '#6145ba' },
    'ROCKET RISE': { label: 'Kids',    color: '#f8991d' },
    'DREAM DROP':  { label: 'Night',   color: '#6145ba' },
  };

  function injectBadges() {
    document.querySelectorAll('a.dayly-rec-card').forEach(function (card) {
      if (card.querySelector('.dayly-rec-card__badge')) return;
      var titleEl = card.querySelector('.dayly-rec-card__title');
      if (!titleEl) return;
      var title = titleEl.textContent.trim().toUpperCase();
      var badge = BADGE_MAP[title];
      if (!badge) return;
      var imgWrap = card.querySelector('.dayly-rec-card__img-wrap');
      if (!imgWrap) return;
      var el = document.createElement('span');
      el.className = 'dayly-rec-card__badge';
      el.textContent = badge.label;
      el.style.background = badge.color;
      imgWrap.insertBefore(el, imgWrap.firstChild);
    });
  }

  // Run once on load
  injectBadges();

  // Watch for dynamic updates (cart drawer open, recs load)
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          n.classList && (n.classList.contains('dayly-rec-card') || n.classList.contains('dayly-recs__grid')) ||
          (n.querySelector && n.querySelector('.dayly-rec-card'))
        );
      });
    });
    if (shouldRun) injectBadges();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
